const integration = {
  PIX_KEY_REGISTERED_IN_SOMEONE_ELSES_NAME: {
    message: 'PIX key registered to someone else',
    code: 'INT_1'
  },
  PIX_KEY_REGISTERED_AT_ANOTHER_INSTITUTION: {
    message: 'PIX key registered at another institution',
    code: 'INT_2'
  },
  PIX_KEY_IN_CLAIM_PROCESS: {
    message: 'PIX key in claim process',
    code: 'INT_3'
  },
  CLAIM_ALREADY_EXISTS_FOR_KEY: {
    message: 'Claim already exists for key',
    code: 'INT_4'
  },
  PIX_ABORTED_SETTLEMENT_TIMEOUT: {
    message: 'Settlement aborted due to timeout',
    code: 'INT_5'
  },
  PIX_ERROR_CREDITOR_AGENT: {
    message: 'Transaction stopped due to error at the Creditor Agent',
    code: 'INT_6'
  },
  PIX_ORDER_REJECTED: {
    message: 'The order was rejected by the bank side (for reasons concerning content)',
    code: 'INT_7'
  },
  PIX_SETTLEMENT_FAILED: {
    message: 'Settlement of the transaction has failed',
    code: 'INT_8'
  },
  PIX_OPERATION_CANCELED_MANUALLY: {
    message: 'Operation canceled manually',
    code: 'INT_9'
  },
  PIX_SPI_ERROR_ELEMENT_INVALID: {
    message: 'A general validation error occurred',
    code: 'INT_10'
  },
  PIX_DENIED_SETTLEMENT_TIMEOUT: {
    message: 'Transaction settlement denied due to counterparty response timeout.',
    code: 'INT_11'
  },
  EMV_EXPIRED: {
    message: 'The EMV is expired',
    code: 'INT_12'
  },
  PIX_DICT_QUERY_UNAVAILABLE: {
    message: 'PBE7026: Service is temporarily unavailable. Please try again'
  },
  PIX_DICT_RATE_LIMIT: {
    message: 'Request blockedExceeded requests/sec limit'
  }
};

module.exports = integration;
